const map = {
  mapLoadFail: "Map loading failed"
} 
export default map